import React from 'react'
import * as Yup from 'yup'
import SumScoredQuestionnaireFields from './SumScoredQuestionnaireFields'
import { createSumScoredQuestionnaireSchema } from './createSumScoredQuestionnaireSchema'

const PCL5_QUESTIONS = [
  {
    key: 'PCL5_QUESTION_1',
    label: 'Repeated, disturbing, and unwanted memories of the stressful experience',
  },
  {
    key: 'PCL5_QUESTION_2',
    label: 'Repeated, disturbing dreams of the stressful experience',
  },
  {
    key: 'PCL5_QUESTION_3',
    label: 'Suddenly feeling or acting as if the stressful experience were actually happening again',
  },
  {
    key: 'PCL5_QUESTION_4',
    label: 'Feeling very upset when something reminded you of the stressful experience',
  },
  {
    key: 'PCL5_QUESTION_5',
    label: 'Having strong physical reactions when something reminded you of the stressful experience',
  },
  {
    key: 'PCL5_QUESTION_6',
    label: 'Avoiding memories, thoughts, or feelings related to the stressful experience',
  },
  {
    key: 'PCL5_QUESTION_7',
    label: 'Avoiding external reminders of the stressful experience',
  },
  {
    key: 'PCL5_QUESTION_8',
    label: 'Trouble remembering important parts of the stressful experience',
  },
  {
    key: 'PCL5_QUESTION_9',
    label: 'Having strong negative beliefs about yourself, other people, or the world',
  },
  {
    key: 'PCL5_QUESTION_10',
    label: 'Blaming yourself or someone else for the stressful experience or what happened after it',
  },
  {
    key: 'PCL5_QUESTION_11',
    label: 'Having strong negative feelings such as fear, horror, anger, guilt, or shame',
  },
  {
    key: 'PCL5_QUESTION_12',
    label: 'Loss of interest in activities that you used to enjoy',
  },
  {
    key: 'PCL5_QUESTION_13',
    label: 'Feeling distant or cut off from other people',
  },
  {
    key: 'PCL5_QUESTION_14',
    label: 'Trouble experiencing positive feelings',
  },
  {
    key: 'PCL5_QUESTION_15',
    label: 'Irritable behavior, angry outbursts, or acting aggressively',
  },
  {
    key: 'PCL5_QUESTION_16',
    label: 'Taking too many risks or doing things that could cause you harm',
  },
  {
    key: 'PCL5_QUESTION_17',
    label: 'Being "superalert" or watchful or on guard',
  },
  {
    key: 'PCL5_QUESTION_18',
    label: 'Feeling jumpy or easily startled',
  },
  {
    key: 'PCL5_QUESTION_19',
    label: 'Having difficulty concentrating',
  },
  {
    key: 'PCL5_QUESTION_20',
    label: 'Trouble falling or staying asleep',
  },
  {
    key: 'PCL5_SCORE',
    label: 'Score',
  },
]

export const PCL5_SCHEMA = createSumScoredQuestionnaireSchema('PCL5', 20, 4)

export type PCL5Schema = Yup.InferType<typeof PCL5_SCHEMA>

const PCL5Fields = () => <SumScoredQuestionnaireFields type="PCL5" questions={PCL5_QUESTIONS} />

export default PCL5Fields
